import _ from 'lodash';
import React, { Fragment } from 'react';
import { Row, Col, PanelGroup, Panel } from 'react-bootstrap'
import Header from '../../Components/Modules/Includes/Header'
import * as actions from '../../Actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Templete from './Templete';
import Notifications, { notify } from 'react-notify-toast';
import MdDelete from 'react-icons/lib/md/delete'

var placeholder = document.createElement("li");
placeholder.className = "placeholder";
// placeholder.innerHTML = "--------Drop Here-------";

const ATTACHMENTS = {
	HL: 'High Level Ceiling Plan',
	LL: 'Low Level Ceiling Plan',
	CT: 'Certification',
	DB: 'DB Schedule',
	EL: 'Emergency Lighting',
	AB: 'As Built Drawings',
	TR: 'Test Results',
	AV: 'Audio Visual',
	OW: 'Other Works',
	FD: 'Fire Detection',
	MV: 'Mechanical and Ventilation',
	SEC: 'Security',
	RP: 'Roof Plan',
	RS: 'Specification',
	MS: 'Miscellaneous',
	MT: 'Maintenance',
	GC: 'Guarantee Certificate',
	SC: 'Sub Contractors/Suppliers',
	SP: 'Specification',
	IV: 'Invoices',
	DC: 'Data Commissioning',
	SF: 'Safety',
	UG: 'User Guide',
	RM: 'Risk and Method Statements',
	CS: 'COSHH Assessments',
	PS: 'Plant and Equipment Schedule',
	AS: 'Asset Schedule',
	DS: 'Datasheets',
	ML: 'Manufacturers Literature',
	TS: 'Test Sheets'
};

const PARTATTATCH = {
	OMDS: 'Datasheets',
	OMQG: 'Quick Reference Guides',
	OMUG: 'User Guides',
	OMAG: 'Advanced User Guide',
	OMCT: 'Certifications'
};
class TempleteSet extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			modalNewTmpSetIsOpen: false,
			formFields: {
				template_set_name: ""
			},
			fieldErrors: {
				template_set_name: ""
			},

			deleteTempSet: {},
			deletingTempSet: false,
			activeKey: 0,
			stockPartsAttachment: ['OMDS', 'OMQG', 'OMUG', 'OMAG', 'OMCT'],
			manaulsAttachment: ['HL', 'LL', 'CT', 'DB', 'EL', 'AB', 'TR', 'AV', 'OW', 'FD', 'MV', 'SEC', 'RP', 'RS', 'MS', 'MT', 'GC', 'SC', 'SP', 'IV', 'DC', 'SF', 'UG','RM', 'CS', 'PS', 'AS', 'DS', 'ML', 'TS']

		}
	}

	dragStart(e) {
		this.dragged = e.currentTarget;
		e.dataTransfer.effectAllowed = 'move';
		e.dataTransfer.setData('text/html', this.dragged);
	}

	dragEnd(e) {
		try {
			this.dragged.style.display = 'block';
			// console.log(" this.dragged value => ", this.dragged, this.dragged.parentNode)
			var element = this.dragged.parentNode.querySelectorAll(".placeholder")
			// console.log(" element value => ", element)
			element[0].parentNode.removeChild(element[0]);
			// this.dragged.parentNode.removeChild(placeholder);
			let stockPartsAttachment = this.state.stockPartsAttachment;
			var from = Number(this.dragged.dataset.id);
			var to = Number(this.over.dataset.id);
			let is_last = (document.getElementsByClassName(e.target.className).length - 1 <= to) ? true : false;
			if (!is_last) {
				if (from < to) to--;
			} else {
				if (from < to) to++;
			}
			stockPartsAttachment.splice(to, 0, stockPartsAttachment.splice(from, 1)[0]);
			this.setState({ stockPartsAttachment: stockPartsAttachment });
			this.AttachmentOrdersave();
			// if(this.dragged.parentNode.placeholder){
			// 	this.dragged.parentNode.removeChild(placeholder);
			// }

		} catch (err) {
			// console.log(err);
		}
	}
	AttachmentOrdersave = () => {
		let compId = this.props.userdetail.companydetail ? this.props.userdetail.companydetail.company_id : '';
		this.props.setAttachmentOrder(compId, this.state.stockPartsAttachment, this.state.manaulsAttachment);
	}
	attachmentDragEnd(e) {
		try {
			this.dragged.style.display = 'block';
			var element = this.dragged.parentNode.querySelectorAll(".placeholder")
			element[0].parentNode.removeChild(element[0]);
			// this.dragged.parentNode.removeChild(placeholder);

			let manaulsAttachment = this.state.manaulsAttachment;
			var from = Number(this.dragged.dataset.id);
			var to = Number(this.over.dataset.id);
			let is_last = (document.getElementsByClassName(e.target.className).length - 1 <= to) ? true : false;
			if (!is_last) {
				if (from < to) to--;
			} else {
				if (from < to) to++;
			}
			manaulsAttachment.splice(to, 0, manaulsAttachment.splice(from, 1)[0]);
			this.setState({ manaulsAttachment: manaulsAttachment });
			this.AttachmentOrdersave();
			// if(this.dragged.parentNode.placeholder){
			// 	this.dragged.parentNode.removeChild(placeholder);
			// }
		} catch (err) {
			// console.log(err)
		}

	}

	attachmentdragOver(e) {
		e.preventDefault();
		this.dragged.style.display = "none";
		if (e.target.className === 'placeholder') return;
		this.over = e.target;
		if (typeof e.target.nextElementSibling === "undefined" || e.target.nextElementSibling == null) {
			e.target.parentNode.insertBefore(placeholder, e.target.nextElementSibling);
		} else {
			e.target.parentNode.insertBefore(placeholder, e.target);
		}

	}

	_closeModalNewTmpSet = () => {
		this.setState({
			modalNewTmpSetIsOpen: false,
			formFields: {
				template_set_name: ""
			},
			fieldErrors: {
				template_set_name: ""
			}
		})
	}

	_openModalNewTmpSet = () => {
		this.setState({
			modalNewTmpSetIsOpen: true
		})
	}

	_updateFormField = (e) => {

		let formFields = {}, fieldErrors = {}
		formFields[e.target.name] = e.target.value
		fieldErrors[e.target.name] = e.target.value.trim().length === 0 ? "This field is required" : ""

		this.setState({
			formFields,
			fieldErrors
		})
	}

	_saveNewTemplateSet = () => {
		let { template_set_name } = this.state.formFields
		const { manualId } = this.props
		template_set_name = template_set_name ? template_set_name.trim() : ""

		if (!template_set_name) {
			this.setState({
				fieldErrors: {
					template_set_name: "This field is required"
				}
			})
		} else {
			this.props.saveTemplateSet(manualId, this.state.formFields)
				.then((err) => {
					if (err) {
						this.setState({
							fieldErrors: err.error
						})
					} else {
						this._closeModalNewTmpSet();
						notify.show('Template set created successfully!', 'success', 5000);
					}
				});
		}
	}

	_deleteTemplateSet = (tmpSetId) => {

		this.setState({
			deletingTempSet: true
		})
		this.props.deleteTemplateSet(tmpSetId).then(() => {
			this._clearDeleteTemplateSet()
			notify.show('Template set deleted successfully!', 'success', 5000);
		});

	}

	_clearDeleteTemplateSet = () => {
		this.setState({
			deleteTempSet: {},
			deletingTempSet: false
		})
	}


	_setTempSetToBeDeleted = (tmpSet) => {

		this.setState({
			deleteTempSet: tmpSet
		})
	}

	componentDidMount() {

		let compId = this.props.userdetail.companydetail ? this.props.userdetail.companydetail.company_id : '';
		if (compId) {
			this.props.getTemplateSet(compId, "details");
			this.props.fetchManuals(compId);
		}
		if (!_.isEmpty(this.props.stockPartsAttachment)) {
			this.setState({
				stockPartsAttachment: this.props.stockPartsAttachment
			})
		}
		if (!_.isEmpty(this.props.manaulsAttachment)) {
			this.setState({
				manaulsAttachment: this.props.manaulsAttachment
			})
		}

	}

	_onTitleClick = (activeKey) => {
		this.setState({
			activeKey: activeKey === this.state.activeKey ? null : activeKey
		})
	}

	render() {

		const templateSet = []
		let companyTemplateSet = this.props.companyTemplateSet
		const actionBtnsAddMore = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this._closeModalNewTmpSet}
				disabled={this.props.newTemplateForm.submitting}
			/>,
			<RaisedButton
				label={this.props.newTemplateForm.submitting === true ? "Saving..." : "Add New Manuals"}
				primary={true}
				labelStyle={{ 'color': '#fff' }}
				keyboardFocused={true}
				onClick={this._saveNewTemplateSet}
				disabled={this.props.newTemplateForm.submitting}
			/>,

		];
		const btnAddMore = (
			<Fragment>
				<buttion className="btn btn-success" onClick={this._openModalNewTmpSet}>
					Add New Template Set
				</buttion>

				<Dialog
					title="Add New Template Set"
					actions={actionBtnsAddMore}
					className="model-support"
					modal={true}
					contentClassName="model-top-overlay no-overlay"
					open={this.state.modalNewTmpSetIsOpen}
					onRequestClose={this._closeModalNewTmpSet}
				>

					<div className="other-popup-content learn-more-popup">
						<form className="import-job-modal">
							<TextField
								required
								fullWidth={true}
								floatingLabelFixed={true}
								placeholder="Template Set Name*"
								name='template_set_name'
								type='text'
								value={this.state.formFields.template_set_name}
								onChange={this._updateFormField}
								errorText={this.state.fieldErrors.template_set_name}
								autocomplete="off"
							/>
						</form>
					</div>
				</Dialog>
			</Fragment>
		)


		companyTemplateSet.map((set, index) => {

			let btnDelete = null
			if (index > 0) {
				btnDelete = (
					<buttion className="pull-right" style={{ cursor: "pointer", marginLeft: "10px" }} title="Delete Template Set" onClick={(e) => {
						e.stopPropagation();
						this._setTempSetToBeDeleted(set)
					}}>
						<MdDelete size="25px" color="#D8543D" />
					</buttion>
				)
			}

			templateSet.push(
				<Panel eventKey={index}>
					<Panel.Heading>
						<Panel.Title className="title-with-info" toggle onClick={() => {
							this._onTitleClick(index)
						}}>
							<span >
								{set.template_set_name}
							</span>
							{(set.template_set_name == 'Master template') ? 
							<div className="manual-info">
									<i className="zmdi zmdi-info"></i>
									<div className="information">
										<p>Select Help from the navigation menu for more information on changing your templates
</p>
									</div>
							</div> : ""}
							{btnDelete}

						</Panel.Title>
					</Panel.Heading>
					<Panel.Body collapsible>
						<Templete userdetail={this.props.userdetail} template_set={set} key={`tmp_set_${set._id}`} />
					</Panel.Body>
				</Panel>

			)

		})

		let modalDeleteSet = null

		if (!_.isEmpty(this.state.deleteTempSet)) {

			const actions = [
				<FlatButton
					label="Cancel"
					primary={true}
					onClick={this._clearDeleteTemplateSet}
					keyboardFocused={true}
					disabled={this.state.deletingTempSet}
				/>,
				<RaisedButton
					label={this.state.deletingTempSet === true ? "Deleting Permanently..." : "Delete"}
					labelStyle={{ 'color': '#fff' }}
					primary={true}
					onClick={(e) => {
						e.stopPropagation()
						this._deleteTemplateSet(this.state.deleteTempSet._id)
					}}
					disabled={this.state.deletingTempSet}
				/>,
			];

			modalDeleteSet = (
				<Dialog
					title={`Are you sure you want to delete the template set "${this.state.deleteTempSet.template_set_name}"?`}
					actions={actions}
					modal={true}
					open={!_.isEmpty(this.state.deleteTempSet)}
				>
					<p>Template Set Name : {this.state.deleteTempSet.template_set_name}</p>
					<br />
					<p>Selected Manuals : {_.keys(this.state.deleteTempSet.selectedManuals).join(", ")}</p>
					<br /><br /><br />
					<p className="text-danger">This can not be undone. It will be deleted permanently.</p>
				</Dialog>
			)
		}
		const { activeKey } = this.state

		let parts_attach_order = this.state.stockPartsAttachment;
		var listItems = parts_attach_order.map((item, i) => {
			return (
				<li
					data-id={i}
					key={i}
					draggable='true'
					onDragEnd={this.dragEnd.bind(this)}
					className="parts-drag"
					onDragStart={this.dragStart.bind(this)}
					style={{ cursor: 'move' }}>{PARTATTATCH[item] ? PARTATTATCH[item]+' ('+item+')' : item}</li>
			)
		});
		let attachment_order = this.state.manaulsAttachment;
		if(!attachment_order.includes("RM")){
			attachment_order.push("RM");
		}
		if(!attachment_order.includes("CS")){
			attachment_order.push("CS");
		}
		if(!attachment_order.includes("PS")){
			attachment_order.push("PS");
		}
		if(!attachment_order.includes("AS")){
			attachment_order.push("AS");
		}
		if(!attachment_order.includes("DS")){
			attachment_order.push("DS");
		}
		if(!attachment_order.includes("ML")){
			attachment_order.push("ML");
		}
		if(!attachment_order.includes("TS")){
			attachment_order.push("TS");
		}
		var attachmentItems = attachment_order.map((item, i) => {
			return (
				<li
					data-id={i}
					key={i}
					draggable='true'
					className="attach-drag"
					onDragEnd={this.attachmentDragEnd.bind(this)}
					onDragStart={this.dragStart.bind(this)}
					style={{ cursor: 'move' }}>{ATTACHMENTS[item] ? ATTACHMENTS[item]+' ('+item+')' : item}</li>
			)
		});

		return (
			<div>
				<Header />
				<Notifications />
				<div className="dashboard-page">
					<div className="right-content-dashboard active-dashboard templete-page">
				
						<Row>
							<Col md={12}>
								<PanelGroup
									accordion
									id="panel-template-set"
									activeKey={activeKey}
								>
									{templateSet}
								</PanelGroup>

							</Col>
						</Row>
						<div className="row" style={{ marginBottom: "15px" }}>
							<div className="col-sm-12 text-right">
								{btnAddMore}
							</div>
						</div>
						{modalDeleteSet}
						<Row>
							<Col md={12} className="grabbable-section include-info">
								<PanelGroup
									accordion
									id="panel-parts-set"
									activeKey={activeKey}
								>
									{/* <h1>Stock Parts Order</h1>
									<ul onDragOver={this.attachmentdragOver.bind(this)}>
										{listItems}
									</ul> */}
									<Panel eventKey={9090}>
										<Panel.Heading>
											<Panel.Title className="title-with-info" toggle onClick={() => {
												this._onTitleClick(9090)
											}}>
												<span >
													Stock Parts Order
												</span>
												<div className="manual-info">
														<i className="zmdi zmdi-info"></i>
														<div className="information">
															<p>Add these codes to the end of your filename e.g. CABLE TEL809_OMDS and reorder how the cover sheets will appear in the final manual</p>
														</div>
												</div>
											</Panel.Title>
										</Panel.Heading>
										<Panel.Body collapsible>
											<ul onDragOver={this.attachmentdragOver.bind(this)}>
												{listItems}
											</ul>
										</Panel.Body>
									</Panel>
									<Panel eventKey={1010}>
										<Panel.Heading>
											<Panel.Title className="title-with-info" toggle onClick={() => {
												this._onTitleClick(1010)
											}}>
												<span >
												Attachment Order
												</span>
												<div className="manual-info">
														<i className="zmdi zmdi-info"></i>
														<div className="information">
															<p>Add these codes to your template codes above e.g. EL_HL and reorder how the cover sheets will appear in the final manual</p>
														</div>
												</div>
											</Panel.Title>
										</Panel.Heading>
										<Panel.Body collapsible>
										<ul onDragOver={this.attachmentdragOver.bind(this)}>
										{attachmentItems}
									</ul>
										</Panel.Body>
									</Panel>
								</PanelGroup>
								{/* <PanelGroup
									accordion
									id="panel-parts-set"
									activeKey={activeKey}
								>
									<h1>Attachment Order</h1>
									<ul onDragOver={this.attachmentdragOver.bind(this)}>
										{attachmentItems}
									</ul>
								</PanelGroup> */}
							</Col>
						</Row>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {

	let manualId = null;
	if (state.templates && state.templates.items && state.templates.items.length > 0) {
		manualId = _.head(state.templates.items).manual;
	}
	return {
		companyTemplateSet: state.company.companyTemplateSet,
		newTemplateForm: state.company.newTemplateForm,
		manualId,
		stockPartsAttachment: state.login.companydetail && state.login.companydetail.stockPartsAttachment,
		manaulsAttachment: state.login.companydetail && state.login.companydetail.manaulsAttachment,
	};
};

TempleteSet = withRouter(connect(
	mapStateToProps,
	actions
)(TempleteSet));

export default TempleteSet;


// WEBPACK FOOTER //
// ./src/Components/Pages/TempleteSet.js